import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Flag.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "transition",
    { attrs: { name: _vm.leaveLeft ? "flag-left" : "flag", appear: "" } },
    [
      _c(
        "div",
        { staticClass: "notification", attrs: { appearance: _vm.appearance } },
        [
          _c(
            "div",
            { staticClass: "header" },
            [
              _c(
                "div",
                { staticClass: "icon" },
                [
                  _c(_vm.flag.name, {
                    tag: "component",
                    staticClass: "icon",
                    attrs: {
                      "primary-color": _vm.flag.primary,
                      "secondary-color": _vm.flag.secondary
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _vm.appearance !== "default"
                ? _c("ChevronDownIcon", {
                    staticClass: "chevron",
                    attrs: { size: "large", expanded: _vm.expanded },
                    nativeOn: {
                      click: function($event) {
                        return _vm.onExpand($event)
                      }
                    }
                  })
                : _c("EditorCloseIcon", {
                    staticClass: "close",
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _vm._t("default", [
            _c(
              "div",
              { staticClass: "content", attrs: { expanded: _vm.expanded } },
              [
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.description) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "actions" },
                  _vm._l(_vm.actions, function(action) {
                    return _c(
                      "a",
                      {
                        key: action.content,
                        staticClass: "action",
                        on: {
                          click: function($event) {
                            return _vm.onClick(action)
                          }
                        }
                      },
                      [_vm._v(_vm._s(action.content))]
                    )
                  }),
                  0
                )
              ]
            )
          ])
        ],
        2
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-776bf2f4";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Flag/Flag.vue.js